type ParamsToString = (...params: Array<string | number | undefined>) => string
export const paramsToString: ParamsToString = (...params) => params.filter(Boolean).join(' ')
